import React from 'react';
import '../styles/StaticPages.css';

const PolitikaPrivatnosti = () => {
  return (
    <div className="static-page">
      <h1>Politika Privatnosti</h1>
      <p className="update-date">Poslednje ažurirano: 25. Maj 2024.</p>

      <section>
        <h2>1. Uvod</h2>
        <p>MyZmaj.net se zalaže za zaštitu ličnih podataka svojih korisnika. Ova Politika privatnosti objašnjava kako prikupljamo, koristimo i štitimo vaše lične podatke.</p>
      </section>

      <section>
        <h2>2. Prikupljeni Podaci</h2>
        <ul>
          <li>Lični podaci koje nam dobrovoljno dostavite prilikom registracije</li>
          <li>Podaci o kupovini i transakcijama</li>
          <li>Tehnički podaci (IP adresa, tip browsera, informacije o uređaju)</li>
          <li>Kolačići (cookies) za funkcionalnost sajta</li>
        </ul>
      </section>

      <section>
        <h2>3. Korišćenje Podataka</h2>
        <p>Podatke koristimo za:</p>
        <ul>
          <li>Izvršavanje narudžbina</li>
          <li>Poboljšanje naših usluga</li>
          <li>Komunikaciju sa korisnicima</li>
          <li>Prevenciju prevara</li>
        </ul>
      </section>

      <section>
        <h2>4. Prava Korisnika</h2>
        <p>Imate pravo da:</p>
        <ul>
          <li>Zatražite pristup svojim podacima</li>
          <li>Ispunite zahtev za ispravku podataka</li>
          <li>Zatražite brisanje podataka</li>
          <li>Ograničite obradu podataka</li>
        </ul>
      </section>

      <section>
        <h2>5. Zaštita Podataka</h2>
        <p>Koristimo SSL enkripciju i redovne sigurnosne provere kako bismo zaštitili vaše podatke.</p>
      </section>

      <section>
        <h2>6. Kontakt</h2>
        <p>Za pitanja o privatnosti, kontaktirajte nas na <a href="mailto:podrska@myzmaj.net">podrska@myzmaj.net</a></p>
      </section>
    </div>
  );
};

export default PolitikaPrivatnosti;